import { t } from '../utilities/lang';
import {
  RoleAdmin,
  RoleAnalyticsManager,
  RoleCampaignManager,
  RoleAccountingAdmin,
} from 'components/Atoms/Icon';

export const VIEW_MODE = {
  GRID: 1,
  LIST: 2,
};

export const SORT_BY_TIME = [
  {
    id: 'Newest',
    name: 'Newest',
  },
  {
    id: 'Oldest',
    name: 'Oldest',
  },
];

export const FORM_INPUT_TYPE = {
  INPUT: 'input',
  INPUT_HTTP: 'input_http',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};

export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*\W)[\w\W]{8,}$/; // Minimum 8 characters, at least one special character, one letter and one number
export const PHONE_PATTERN = /^\d{10}$/;
export const SUBDOMAIN_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]+[a-zA-Z0-9]$/;

// Simpler pattern: require http(s)://, domain, optional path/query/hash
export const DOMAIN_PATTERN = /^(https?:\/\/)([\w.-]+)(:[0-9]+)?(\/[\w\-.~!$&'()*+,;=:@%]*)*(\?[\w\-.~!$&'()*+,;=:@%/?]*)?(#[\w\-.~!$&'()*+,;=:@%/?]*)?$/i;

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const FILE_ACCEPT = {
  PDF: 'application/pdf, ',
  DOC: '.doc,.docx, ',
  DOCX: '.docx, ',
  CONTRACT: 'application/pdf',
  XLS: 'application/vnd.ms-excel, ',
  DOCUMENT: 'application/pdf, application/msword, application/vnd.ms-excel',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ALLOW: 405,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
};

export const GENERATE_OTP_ACTIONS = {
  REGISTER: 'Register',
  UPDATE_EMAIL: 'UpdateNewEmail',
  CONFIRM_EMAIL: 'ConfirmOldEmail',
  FORGOT_PASSWORD: 'ForgotPassword',
  RESET_PASSWORD: 'ResetPassword',
};

export const COMMON_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  PENDING: 3,
};

export const USER_ROLES = {
  ADMIN: 'Admin',
  EMPLOYEE: 'Employee',
  USER: 'User',
  INDIVIDUAL: 'Individual',
  MANAGER: 'Manager',
};

export const STATUS = [
  {
    id: 1,
    name: 'Active',
  },
  {
    id: 2,
    name: 'Inactive',
  },
];

export const ROLE_OPTIONS = [
  {
    id: 'admin',
    name: 'Admin',
  },
  {
    id: 'employee',
    name: 'Employee',
  },
];

export const USER_STATUS_OPTIONS = [
  {
    id: undefined,
    name: 'All',
  },
  {
    id: 'active',
    name: 'Active',
  },
  {
    id: 'inactive',
    name: 'Inactive',
  },
];

export const USER_STATUS_WAITING_OPTIONS = [
  {
    id: undefined,
    name: 'All',
  },
  {
    id: 'Pending',
    name: 'Pending',
  },
  {
    id: 'Approved',
    name: 'Approved',
  },
  {
    id: 'Rejected',
    name: 'Rejected',
  },
];

export const USER_ROLE_TYPES = {
  AGENCY: 'Agency',
  ORGANIZATION: 'Organization',
  CAMPAIGN: 'Campaign',
};

export const CUSTOMER_TITLE = {
  OWNER: 'Owner',
  EMPLOYEE: 'Employee',
};

export const CUSTOMER_ROLE_OPTIONS = [
  {
    id: 'Agency',
    name: 'Agency',
  },
  {
    id: 'Organization',
    name: 'Organization',
  },
  {
    id: 'Campaign',
    name: 'Campaign',
  },
];

export const USER_LEVEL_TYPE = {
  ADMIN: 'Admin',
  ACCOUNTING_ADMIN: 'AccountingAdmin',
  CAMPAIGN_MANAGER: 'CampaignManager',
  ANALYTIC_MANAGER: 'AnalyticManager',
};

export const USER_LEVEL_LABEL = {
  [USER_LEVEL_TYPE.ADMIN]: t('common.user_level_label.admin'),
  [USER_LEVEL_TYPE.ACCOUNTING_ADMIN]: t('common.user_level_label.accounting_admin'),
  [USER_LEVEL_TYPE.CAMPAIGN_MANAGER]: t('common.user_level_label.campaign_manager'),
  [USER_LEVEL_TYPE.ANALYTIC_MANAGER]: t('common.user_level_label.analytics_manager'),
};

export const USER_LEVEL_TYPE_OPTIONS = [
  {
    id: USER_LEVEL_LABEL[USER_LEVEL_TYPE.ADMIN],
    name: t('common.user_level_label.admin'),
    iconModal: RoleAdmin,
    content: t('user_level_type_options.admin_content'),
  },
  {
    id: USER_LEVEL_TYPE.CAMPAIGN_MANAGER,
    name: USER_LEVEL_LABEL[USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
    iconModal: RoleCampaignManager,
    content: t('user_level_type_options.campaign_manager_content'),
  },
  {
    id: USER_LEVEL_TYPE.ANALYTIC_MANAGER,
    name: USER_LEVEL_LABEL[USER_LEVEL_TYPE.ANALYTIC_MANAGER],
    iconModal: RoleAnalyticsManager,
    content: t('user_level_type_options.analytic_manager_content'),
  },
  {
    id: USER_LEVEL_TYPE.ACCOUNTING_ADMIN,
    name: USER_LEVEL_LABEL[USER_LEVEL_TYPE.ACCOUNTING_ADMIN],
    iconModal: RoleAccountingAdmin,
    content: t('user_level_type_options.accounting_admin_content'),
  },
];

export const TEAM_MEMBER_STATUS_OPTIONS = [
  {
    id: 'Active',
    name: t('common.team_member_status.active'),
  },
  {
    id: 'InActive',
    name: t('common.team_member_status.inactive'),
  },
  {
    id: 'PendingInvite',
    name: t('common.team_member_status.pending_invite'),
  },
];

export const USER_TYPE = {
  PORTAL: 'Portal',
  CUSTOMER: 'Customer',
};

export const USER_TABS = {
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  USER_LIST: 'USER_LIST',
};

export const PAYMENT_METHOD_TYPE = {
  CARD: 'Card',
  ACH_ACCOUNT: 'AchAccount',
};

export const PAYMENT_METHOD_TYPE_NAME = {
  [PAYMENT_METHOD_TYPE.CARD]: t('common.payment_method.credit_card'),
  [PAYMENT_METHOD_TYPE.ACH_ACCOUNT]: t('common.payment_method.ach_account'),
};

export const TRANSFER_TYPE = {
  TOP_UP: 'TopUp',
  PAYMENT: 'Payment',
  DEDUCT: 'Deduct',
  REFUND: 'Credit',
};

export const MAP_TRANSFER_TYPE_NAME = {
  [TRANSFER_TYPE.TOP_UP]: t('common.transfer_type.wallet_top_up'),
  [TRANSFER_TYPE.PAYMENT]: t('common.transfer_type.payment'),
  [TRANSFER_TYPE.DEDUCT]: t('common.transfer_type.deduction'),
  [TRANSFER_TYPE.REFUND]: t('common.transfer_type.credit'),
};

export const WALLET_TRANSACTION_TRANSFER_TYPE = [
  {
    id: TRANSFER_TYPE.TOP_UP,
    name: MAP_TRANSFER_TYPE_NAME[TRANSFER_TYPE.TOP_UP],
  },
  {
    id: TRANSFER_TYPE.PAYMENT,
    name: MAP_TRANSFER_TYPE_NAME[TRANSFER_TYPE.PAYMENT],
  },
  {
    id: TRANSFER_TYPE.DEDUCT,
    name: MAP_TRANSFER_TYPE_NAME[TRANSFER_TYPE.DEDUCT],
  },
  {
    id: TRANSFER_TYPE.REFUND,
    name: MAP_TRANSFER_TYPE_NAME[TRANSFER_TYPE.REFUND],
  },
];

export const CARD_TYPES = {
  VISA: 'visa',
  MASTER: 'mastercard',
};

export const MONTH_IN_TEXT = {
  1: t('common.month.january'),
  2: t('common.month.february'),
  3: t('common.month.march'),
  4: t('common.month.april'),
  5: t('common.month.may'),
  6: t('common.month.june'),
  7: t('common.month.july'),
  8: t('common.month.august'),
  9: t('common.month.september'),
  10: t('common.month.october'),
  11: t('common.month.november'),
  12: t('common.month.december'),
};

export const AUDIENCE_TYPE = {
  STANDARD: 'StandardTargeting',
  VOTER_FILE: 'VoterFileTargeting',
  PERSONAL_DATA: 'PersonalDataTargeting',
  RETARGETING: 'ReTargeting',
  ONE_CLICK_CURATED: 'CuratedTargeting',
  CUSTOM: 'CustomTargeting',
  PREVIOUS_SAVED: 'PreviousSavedTargeting',
};

export const AUDIENCE_TYPE_NAME = {
  [AUDIENCE_TYPE.STANDARD]: t('common.audience_type.standard_targeting'),
  [AUDIENCE_TYPE.VOTER_FILE]: t('common.audience_type.voter_file_crm_targeting'),
  [AUDIENCE_TYPE.PERSONAL_DATA]: t('common.audience_type.personal_data_targeting'),
  [AUDIENCE_TYPE.RETARGETING]: t('common.audience_type.retargeting'),
  [AUDIENCE_TYPE.ONE_CLICK_CURATED]: t('common.audience_type.one_click_curated_targeting'),
  [AUDIENCE_TYPE.CUSTOM]: t('common.audience_type.custom_targeting'),
};

export const AUDIENCE_TYPE_OPTIONS = [
  {
    id: AUDIENCE_TYPE.STANDARD,
    name: t('common.audience_type.standard_targeting'),
  },
  {
    id: AUDIENCE_TYPE.VOTER_FILE,
    name: t('common.audience_type.voter_file_targeting'),
  },
  {
    id: AUDIENCE_TYPE.PERSONAL_DATA,
    name: t('common.audience_type.personal_data_targeting'),
  },
  {
    id: AUDIENCE_TYPE.RETARGETING,
    name: t('common.audience_type.retargeting'),
  },
  {
    id: AUDIENCE_TYPE.CUSTOM,
    name: t('common.audience_type.custom_targeting'),
  },
];

export const AUDIENCE_STATUS = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  INACTIVE: 'InActive',
};

export const USER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'InActive',
  PENDING: 'PendingInvite',
};

export const AD_TYPES = {
  MEDIUM_RECTANGLE: '300x250',
  LEADERBOARD: '728x90',
  HALF_PAGE: '300x600',
  BILLBOARD: '970x250',
  WIDE_SKYCRAPER: '160x600',
  MOBILE_LEADERBOARD: '320x50',
};

export const AD_TYPES_OBJ = {
  [AD_TYPES.MEDIUM_RECTANGLE]: {
    id: AD_TYPES.MEDIUM_RECTANGLE,
    name: t('ad_types.medium_rectangle'),
    className: 'medium-rectangle',
  },
  [AD_TYPES.LEADERBOARD]: {
    id: AD_TYPES.LEADERBOARD,
    name: t('ad_types.leaderboard'),
    className: 'leaderboard',
  },
  [AD_TYPES.HALF_PAGE]: {
    id: AD_TYPES.HALF_PAGE,
    name: t('ad_types.half_page_ad'),
    className: 'hafl-page-ad',
  },
  [AD_TYPES.BILLBOARD]: {
    id: AD_TYPES.BILLBOARD,
    name: t('ad_types.billboard'),
    className: 'billboard',
  },
  [AD_TYPES.WIDE_SKYCRAPER]: {
    id: AD_TYPES.WIDE_SKYCRAPER,
    name: t('ad_types.wide_skycraper'),
    className: 'wide-skycraper',
  },
  [AD_TYPES.MOBILE_LEADERBOARD]: {
    id: AD_TYPES.MOBILE_LEADERBOARD,
    name: t('ad_types.mobile_leaderboard'),
    className: 'mobile-leaderboard',
  },
};

export const DATE_ACTIONS = {
  START: 'start',
  END: 'end',
};

export const CUSTOMIZE_TEMPALTE_STEPS = [
  t('customize_template_steps.choose_template'),
  t('customize_template_steps.redirect_to_canva'),
  t('customize_template_steps.save_and_download'),
  t('customize_template_steps.return_and_upload'),
];

export const CREATIVES_STATUS = {
  PENDING: 'Pending',
  IN_REVIEW: 'InReview',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const POLITICAL_TYPES_KEY = {
  Federal: 'Federal',
  StateLocalRace: 'StateLocalRace',
};

export const POLITICAL_TYPES_NAME = {
  [POLITICAL_TYPES_KEY.Federal]: t('common.political_types.federal'),
  [POLITICAL_TYPES_KEY.StateLocalRace]: t('common.political_types.state'),
};

export const BALANCE_MODAL_TYPE = {
  BALANCE_SDK: 'balance-sdk',
  BALANCE_CHECKOUT: 'balance-checkout',
  BALANCE_CHECKOUT_TOPUP: 'balance-checkout-topup',
};

export const PAYMENT_METHOD_BALANCE_TYPE = {
  CREDIT_CARD: 'creditCard',
  ACH_DEBIT: 'achDebit',
  PADS: 'pads',
};

export const TRANSACTION_TYPE = {
  TOPUP: 'TopUp',
  TEMPLATE_PAYMENT: 'TemplatePayment',
  CAMPAIGN_PAYMENT: 'CampaignPayment',
  UPSELL_CREATIVE_PAYMENT: 'UpSellCreativePayment',
  UPSELL_AUDIENCE_PAYMENT: 'UpSellAudiencePayment',
};

export const QUALIFICATION_STATUS = {
  PENDING: 'Pending',
  PENDING_ACTIVATION: 'PendingActivation',
  ACTIVE: 'Active',
  DECLINED: 'Declined',
  IN_REVIEW: 'InReview',
  SUSPENDED: 'Suspended',
  TERMINATED: 'Terminated',
  REVIEW_LIMIT_INCREASE: 'ReviewLimitIncrease'
};

export const QUALIFICATION_STATUS_LABEL = {
  [QUALIFICATION_STATUS.PENDING]: t('common.qualification_status.pending'),
  [QUALIFICATION_STATUS.PENDING_ACTIVATION]: t('common.qualification_status.pending_activation'),
  [QUALIFICATION_STATUS.ACTIVE]: t('common.qualification_status.active'),
  [QUALIFICATION_STATUS.DECLINED]: t('common.qualification_status.declined'),
  [QUALIFICATION_STATUS.IN_REVIEW]: t('common.qualification_status.in_review'),
  [QUALIFICATION_STATUS.SUSPENDED]: t('common.qualification_status.suspended'),
  [QUALIFICATION_STATUS.TERMINATED]: t('common.qualification_status.terminated'),
  [QUALIFICATION_STATUS.REVIEW_LIMIT_INCREASE]: t('common.qualification_status.review_limit_increase')
};

export const TRANSACTIONID = 'transactionId';
export const AMOUNT = 'amount';

export const DEFAULT_BALANCE_OPTIONS_CHECKOUT = {
  isAuth: false, // Setting to true will only authorize the transaction and allow to capture later.
  hideDueDate: false, // Setting to true will hide the charge date
  skipSuccessPage: false, // Setting to true will close the modal after payment submission.
  achDebitConnectOptions: ['IMMEDIATE'],
  allowedPaymentMethods: [
    'creditCard',
    'bank',
    'check',
    'payWithTerms',
    'invoice',
    'pads',
    'paySupplier',
  ], // Override the payment methods that are set on the created transaction.
  onClose: () => {},
  onCancel: () => {
    console.log('cancel modal checkout');
  },
  onSuccess: () => {},
  onError: () => {
    console.log('the transaction has error');
  },

  // hideNoTerms?: boolean // Prevents selecting no terms option
};

export const DEFAULT_BALANCE_PAYMENT_METHOD_OPTIONS = {
  allowedPaymentMethods: ['creditCard', 'achDebit'],
  onSuccess: () => {
    console.log('completed with success!');
  },
  onError: (error) => {},
  onClose: () => {},
  onCancel: () => {
    console.log('payment method modal cancelled');
  },
  onOpen: () => {},
};

export const PAYMENT_TYPE = {
  CREDIT_CARD: 'Card',
  BANK: 'AchAccount',
  ACCOUNT_BALANCE: 'AccountBalance',
  WIRE_TRANSFER: 'WireTransfer',
  DISCOUNT_CODE: 'DiscountCode',
  DISCOUNT_CODE: 'DiscountCode',
  TERM: 'Term',
};

export const CAMPAIGN_STATUS = {
  WAITING_FOR_PAYMENT: 'WaitingForPayment',
  COMPLETED: 'Completed',
  DRAFT: 'Draft',
};

export const PAYMENT_INTENT_TYPE = {
  TOP_UP: 'TopUp',
  TEMPLATE_PAYMENT: 'TemplatePayment',
  CUSTOM_VIDEO_PRODUCTION_PAYMENT: 'CustomVideoProductionPayment',
  CUSTOM_DISPLAY_CREATIVE_PAYMENT: 'CustomDisplayCreativePayment',
  CAMPAIGN_PAYMENT: 'CampaignPayment',
  UPSELL_CREATIVE_PAYMENT: 'UpSellCreativePayment',
  UPSELL_AUDIENCE_PAYMENT: 'UpSellAudiencePayment',
};

export const CODE_TYPE = {
  DISCOUNT: 'discount',
  VOUCHER: 'voucher',
};

export const WALLET_TABS = {
  TOP_UP: 'topUp',
  VOUCHER: 'voucherCode',
};

export const WALLET_TRANSACTION_TABS = {
  TRANSACTION_HISTORY: 'transactionHistory',
  PAYMENT_METHOD: 'paymentMethod',
};

export const ADVERTISER_STATUS = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};

export const CAMPAIGN_STEPNAME = {
  BUDGET_OR_END_DATE: 'BudgetOrEndDate',
  AD_SETS: 'AdSets',
  GEO_TARGETING: 'GeoTargeting',
  AUDIENCE_TARGETING: 'AudienceTargeting',
  CREATIVES: 'Creatives',
};

export const LIST_CAMPAIGN_STEPNAME = [
  {
    id: CAMPAIGN_STEPNAME.BUDGET_OR_END_DATE,
    name: 'Budget or End date',
    currentStep: 1,
  },
  {
    id: CAMPAIGN_STEPNAME.AD_SETS,
    name: 'Ad Sets',
    currentStep: 2,
  },
  {
    id: CAMPAIGN_STEPNAME.GEO_TARGETING,
    name: 'Geo-Targeting',
    currentStep: 3,
  },
  {
    id: CAMPAIGN_STEPNAME.AUDIENCE_TARGETING,
    name: 'Audience Targeting',
    currentStep: 4,
  },
  {
    id: CAMPAIGN_STEPNAME.CREATIVES,
    name: 'Creatives',
    currentStep: 5,
  },
];

// paymentMethodType
// Card, AchAccount, WireTransfer, AccountBalance or DiscountCode

export const WALLET_TRANSACTION_PAYMENT_METHOD_TYPE = {
  CARD: 'Card',
  ACH_ACCOUNT: 'AchAccount',
  WIRE_TRANSFER: 'WireTransfer',
  ACCOUNT_BALANCE: 'AccountBalance',
  DISCOUNT_CODE: 'DiscountCode',
};

export const MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME = {
  [WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.CARD]: t('common.wallet_transaction_payment_method_type.card'),
  [WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACH_ACCOUNT]: t('common.wallet_transaction_payment_method_type.ach_account'),
  [WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.WIRE_TRANSFER]: t('common.wallet_transaction_payment_method_type.wire_transfer'),
  [WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACCOUNT_BALANCE]: t('common.wallet_transaction_payment_method_type.account_balance'),
  [WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.DISCOUNT_CODE]: t('common.wallet_transaction_payment_method_type.discount_code'),
};

export const WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_OPTIONS = [
  {
    id: WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.CARD,
    name: MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME[
      WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.CARD
    ],
  },
  {
    id: WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACH_ACCOUNT,
    name: MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME[
      WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACH_ACCOUNT
    ],
  },
  {
    id: WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.WIRE_TRANSFER,
    name: MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME[
      WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.WIRE_TRANSFER
    ],
  },
  {
    id: WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACCOUNT_BALANCE,
    name: MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME[
      WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.ACCOUNT_BALANCE
    ],
  },
  {
    id: WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.DISCOUNT_CODE,
    name: MAP_WALLET_TRANSACTION_PAYMENT_METHOD_TYPE_NAME[
      WALLET_TRANSACTION_PAYMENT_METHOD_TYPE.DISCOUNT_CODE
    ],
  },
];
